import { render, staticRenderFns } from "./DataCentreReport.vue?vue&type=template&id=56a4f03f&scoped=true"
import script from "./DataCentreReport.vue?vue&type=script&lang=js"
export * from "./DataCentreReport.vue?vue&type=script&lang=js"
import style0 from "./DataCentreReport.vue?vue&type=style&index=0&id=56a4f03f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a4f03f",
  null
  
)

export default component.exports